<script setup>
import { ref, reactive, toRefs, onBeforeMount, watchEffect } from 'vue';
const props = defineProps({
  endDate: String,
});
const { endDate } = toRefs(props);
const data = reactive({
  Day: 0,
  Hours: '00',
  Minutes: '00',
  Seconds: '00',
  timer: null,
});
const emit = defineEmits(['close']);
const ff = (num) => {
  const number = Math.floor(num);
  return number < 10 ? `0${number}` : number;
};
const getTimeDown = () => {
  const nowDate = new Date().getTime();
  let timeStr = +endDate.value * 1000 + 10 * 24 * 60 * 60000 - nowDate;
  // let timeStr = +endDate.value * 1000 + 10 * 60000 - nowDate;

  data.timer = setInterval(() => {
    timeStr = timeStr - 1000;
    if (timeStr <= 1000) {
      emit('close');
      clearInterval(data.timer);
      data.Hours = '00';
      data.Minutes = '00';
      data.Seconds = '00';
    } else {
      const day = Math.floor(timeStr / 1000 / (60 * 60 * 24));
      const hours = ff(((timeStr / 1000 / (60 * 60)) % 24) + day * 24);
      const minutes = ff((timeStr / 1000 / 60) % 60);
      const seconds = ff((timeStr / 1000) % 60);
      data.Day = day;
      data.Hours = hours + '';
      data.Minutes = minutes + '';
      data.Seconds = seconds + '';
    }
  }, 1000);
};
watchEffect(() => {
  if (endDate.value) {
    data.timer && clearInterval(data.timer);
    getTimeDown();
  }
});
</script>
<template>
  <div class="count center Wcolor Bold flex_center">
    {{ data.Hours }} : {{ data.Minutes }} : {{ data.Seconds }}
  </div>
</template>

<style lang="scss" scoped>
.count {
  border-radius: 4px;
  border: 1px solid $white;
}
</style>
